import {
  Option,
  EstateSubCategoryOption,
  CommercialSubCategoryOption,
  LandSubCategoryOption,
  InterestOption,
  FloorOption,
  HeatOption,
  HeatTypeOption,
  EstateConditionOption,
  CommercialConditionOption,
  ParkingOption,
  GardenOption,
  DoorOption,
  EnergyClassOption,
  FrameOption,
  WindowOption,
  FloorTypeOption,
  AccessOption,
  DirectionOption,
  ViewOption,
  PoolOption,
  UsageOption,
  PlanOption,
  LandConditionOption,
  ElectricityTypeOption,
  EquipmentOption,
} from './types'

export const EMPTY_OPTION: Option = {
  label: 'manageEstateAd.steps.estateCategory.choose.name',
  value: '',
}
export const EMPTY_RADIO_OPTION: Option = {
  label: 'manageEstateAd.steps.estateCategory.emptyRadio.label',
  value: '',
}
export const YES_RADIO_OPTION: Option = {
  label: 'manageEstateAd.steps.estateCategory.radio.yes.label',
  value: '',
}
export const NO_RADIO_OPTION: Option = {
  label: 'manageEstateAd.steps.estateCategory.radio.no.label',
  value: '',
}

export const CATEGORIES: Option[] = [
  {
    label: 'manageEstateAd.steps.estateCategory.residence.name',
    value: 'estate',
  },
  {
    label: 'manageEstateAd.steps.estateCategory.commercial.name',
    value: 'commercial',
  },
  { label: 'manageEstateAd.steps.estateCategory.land.name', value: 'land' },
]

export const ESTATE_SUB_CATEGORIES: EstateSubCategoryOption[] = [
  {
    label: 'property.estatePropertyType.appartment.base',
    value: 'appartment',
  },
  {
    label: 'property.estatePropertyType.singleResidence.base',
    value: 'single_residence',
  },
  {
    label: 'property.estatePropertyType.maisonette.base',
    value: 'maisonette',
  },
  {
    label: 'property.estatePropertyType.building.base',
    value: 'building',
  },
  {
    label: 'property.estatePropertyType.restTypes.base',
    value: 'rest_types',
  },
]

export const COMMERCIAL_SUB_CATEGORIES: CommercialSubCategoryOption[] = [
  {
    label: 'property.estatePropertyCommercialType.office.base',
    value: 'office',
  },
  {
    label: 'property.estatePropertyCommercialType.store.base',
    value: 'store',
  },
  {
    label: 'property.estatePropertyCommercialType.industrialArea.base',
    value: 'industrial_area',
  },
  {
    label: 'property.estatePropertyCommercialType.craftSpace.base',
    value: 'craft_space',
  },
  {
    label: 'property.estatePropertyCommercialType.warehouse.base',
    value: 'warehouse',
  },
  {
    label: 'property.estatePropertyCommercialType.hotel.base',
    value: 'hotel',
  },
  {
    label: 'property.estatePropertyCommercialType.building.base',
    value: 'commercial_building',
  },
  {
    label: 'property.estatePropertyCommercialType.hall.base',
    value: 'hall',
  },
  {
    label: 'property.estatePropertyCommercialType.parking.base',
    value: 'parking',
  },
  {
    label: 'property.estatePropertyCommercialType.restTypes.base',
    value: 'rest_commercial_types',
  },
]

export const LAND_SUB_CATEGORIES: LandSubCategoryOption[] = [
  {
    label: 'property.estatePropertyLandType.plotOfLand.base',
    value: 'plot_of_land',
  },
  {
    label: 'property.estatePropertyLandType.island.base',
    value: 'island',
  },
  {
    label: 'property.estatePropertyLandType.plot.base',
    value: 'plot',
  },
  {
    label: 'property.estatePropertyLandType.otherLandTypes.base',
    value: 'other_land_types',
  },
]

export const INTEREST_OPTIONS: InterestOption[] = [
  {
    label: 'manageEstateAd.steps.estateCategory.sale',
    value: 'buy',
  },
  {
    label: 'manageEstateAd.steps.estateCategory.rent',
    value: 'loan',
  },
]

export const ESTATE_CONDITION_OPTIONS: EstateConditionOption[] = [
  {
    label: 'property.estatePropertyCondition.needOfRenovation.base',
    value: 'need_of_renovation',
  },
  // {
  //   label: 'property.estatePropertyCondition.needOfRenovationFull.base',
  //   value: 'need_of_renovation_full',
  // },
  {
    label: 'property.estatePropertyCondition.renovated.base',
    value: 'renovated',
  },
  {
    label: 'property.estatePropertyCondition.newBuilt.base',
    value: 'new_built',
  },
  // {
  //   label: 'property.estatePropertyCondition.semiBuilt.base',
  //   value: 'semi_built',
  // },

  // {
  //   label: 'property.estatePropertyCondition.goodCondition.base',
  //   value: 'good_condition',
  // },
  // {
  //   label: 'property.estatePropertyCondition.buildable.base',
  //   value: 'buildable',
  // },
  {
    label: 'property.estatePropertyCondition.underConstruction.base',
    value: 'under_construction',
  },
  // {
  //   label: 'property.estatePropertyCondition.underCompletion.base',
  //   value: 'under_completion',
  // },
  // {
  //   label: 'property.estatePropertyCondition.veryGood.base',
  //   value: 'very_good',
  // },
  // {
  //   label: 'property.estatePropertyCondition.freshPainted.base',
  //   value: 'fresh_painted',
  // },
  // {
  //   label: 'property.estatePropertyCondition.moderate.base',
  //   value: 'moderate',
  // },
  // {
  //   label: 'property.estatePropertyCondition.amazing.base',
  //   value: 'amazing',
  // },
  // {
  //   label: 'property.estatePropertyCondition.minimalDesign.base',
  //   value: 'minimal_design',
  // },
  // {
  //   label: 'property.estatePropertyCondition.in_the_drawings.base',
  //   value: 'in_the_drawings',
  // },
  // {
  //   label: 'property.estatePropertyCondition.neoclassic.base',
  //   value: 'neoclassic',
  // },
]

export const COMMERCIAL_CONDITION_OPTIONS: CommercialConditionOption[] = [
  {
    label: 'property.estatePropertyCondition.renovated.base',
    value: 'renovated',
  },
  {
    label: 'property.estatePropertyCondition.newBuilt.base',
    value: 'new_built',
  },
  {
    label: 'property.estatePropertyCondition.underConstruction.base',
    value: 'under_construction',
  },
]

export const FLOOR_OPTIONS: FloorOption[] = [
  {
    value: '2nd_basement',
    label: 'property.estatePropertyFloor.2ndBasement.base',
    order: 1,
  },
  {
    value: 'basement',
    label: 'property.estatePropertyFloor.basement.base',
    order: 2,
  },
  {
    value: 'semi_basment',
    label: 'property.estatePropertyFloor.semiBasement.base',
    order: 3,
  },
  {
    value: 'mezzanine',
    label: 'property.estatePropertyFloor.mezzanine.base',
    order: 4,
  },
  {
    value: 'mezzanine_raised',
    label: 'property.estatePropertyFloor.mezzanineRaised.base',
    order: 5,
  },
  {
    value: 'ground_floor',
    label: 'property.estatePropertyFloor.groundFloor.base',
    order: 6,
  },
  {
    value: 'ground_floor_raised',
    label: 'property.estatePropertyFloor.groundFloorRaised.base',
    order: 7,
  },
  {
    value: '1st',
    label: 'property.estatePropertyFloor.1st.base',
    order: 8,
  },
  {
    value: '1st_raised',
    label: 'property.estatePropertyFloor.1stRaised.base',
    order: 9,
  },
  {
    value: '2nd',
    label: 'property.estatePropertyFloor.2nd.base',
    order: 10,
  },
  {
    value: '3rd',
    label: 'property.estatePropertyFloor.3rd.base',
    order: 11,
  },
  {
    value: '4th',
    label: 'property.estatePropertyFloor.4th.base',
    order: 12,
  },
  {
    value: '5th',
    label: 'property.estatePropertyFloor.5th.base',
    order: 13,
  },
  {
    value: '6th',
    label: 'property.estatePropertyFloor.6th.base',
    order: 14,
  },
  {
    value: '7th',
    label: 'property.estatePropertyFloor.7th.base',
    order: 15,
  },
  {
    value: '8th',
    label: 'property.estatePropertyFloor.8th.base',
    order: 16,
  },
  {
    value: '9th',
    label: 'property.estatePropertyFloor.9th.base',
    order: 17,
  },
  {
    value: '10th',
    label: 'property.estatePropertyFloor.10th.base',
    order: 18,
  },
  {
    value: '11th',
    label: 'property.estatePropertyFloor.11th.base',
    order: 19,
  },
  {
    value: '12th',
    label: 'property.estatePropertyFloor.12th.base',
    order: 20,
  },
  {
    value: '13th',
    label: 'property.estatePropertyFloor.13th.base',
    order: 21,
  },
  {
    value: '14th',
    label: 'property.estatePropertyFloor.14th.base',
    order: 22,
  },
  {
    value: '15th',
    label: 'property.estatePropertyFloor.15th.base',
    order: 23,
  },
  {
    value: '16th',
    label: 'property.estatePropertyFloor.16th.base',
    order: 24,
  },
  {
    value: '17th',
    label: 'property.estatePropertyFloor.17th.base',
    order: 25,
  },
  {
    value: '18th',
    label: 'property.estatePropertyFloor.18th.base',
    order: 26,
  },
  {
    value: '19th',
    label: 'property.estatePropertyFloor.19th.base',
    order: 27,
  },
  {
    value: '20th',
    label: 'property.estatePropertyFloor.20th.base',
    order: 28,
  },
  {
    value: '20+',
    label: 'property.estatePropertyFloor.20+.base',
    order: 29,
  },
]

export const HEAT_OPTIONS: HeatOption[] = [
  {
    label: 'property.estatePropertyHeat.without.base',
    value: 'heat_without',
  },
  {
    label: 'property.estatePropertyHeat.central.base',
    value: 'heat_central',
  },
  {
    label: 'property.estatePropertyHeat.individual.base',
    value: 'heat_individual',
  },
  {
    label: 'property.estatePropertyHeat.autonomous.base',
    value: 'heat_autonomous',
  },
]

export const HEAT_TYPE_OPTIONS: HeatTypeOption[] = [
  {
    label: 'property.estatePropertyHeatType.naturalGas.base',
    value: 'heat_type_natural_gas',
  },
  {
    label: 'property.estatePropertyHeatType.convector.base',
    value: 'heat_type_convector',
  },
  {
    label: 'property.estatePropertyHeatType.geothermalPower.base',
    value: 'heat_type_geothermal_power',
  },
  {
    label: 'property.estatePropertyHeatType.thermalAccumulator.base',
    value: 'heat_type_thermal_accumulator',
  },
  {
    label: 'property.estatePropertyHeatType.electricity.base',
    value: 'heat_type_electricity',
  },
  {
    label: 'property.estatePropertyHeatType.liquidGas.base',
    value: 'heat_type_liquid_gas',
  },
  {
    label: 'property.estatePropertyHeatType.underfloor.base',
    value: 'heat_type_underfloor',
  },
  {
    label: 'property.estatePropertyHeatType.airConditioning.base',
    value: 'heat_type_air_conditioning',
  },
  {
    label: 'property.estatePropertyHeatType.stove.base',
    value: 'heat_type_stove',
  },
  {
    label: 'property.estatePropertyHeatType.pellet.base',
    value: 'heat_type_pellet',
  },
  {
    label: 'property.estatePropertyHeatType.fanCoil.base',
    value: 'heat_type_fan_coil',
  },
  {
    label: 'property.estatePropertyHeatType.teleheating.base',
    value: 'heat_type_teleheating',
  },
  {
    label: 'property.estatePropertyHeatType.infrared.base',
    value: 'heat_type_infrared',
  },
  {
    label: 'property.estatePropertyHeatType.petrol.base',
    value: 'heat_type_petrol',
  },
  {
    label: 'property.estatePropertyHeatType.heatPump.base',
    value: 'heat_type_heat_pump',
  },
  {
    label: 'property.estatePropertyHeatType.unspecified.base',
    value: 'heat_type_unspecified',
  },
]

export const PARKING_TYPE_OPTIONS: ParkingOption[] = [
  {
    label: 'property.estatePropertyParking.has.base',
    value: 'has',
  },
  {
    label: 'property.estatePropertyParking.hasNot.base',
    value: 'has_not',
  },
  {
    label: 'property.estatePropertyParking.open.base',
    value: 'open',
  },
  {
    label: 'property.estatePropertyParking.closed.base',
    value: 'closed',
  },
  {
    label: 'property.estatePropertyParking.pilot.base',
    value: 'pilot',
  },
  {
    label: 'property.estatePropertyParking.basement.base',
    value: 'basement',
  },
]

export const DOOR_OPTIONS: DoorOption[] = [
  {
    label: 'property.estatePropertyDoor.door_simple.base',
    value: 'simple',
  },
  {
    label: 'property.estatePropertyDoor.door_armored.base',
    value: 'armored',
  },
  {
    label: 'property.estatePropertyDoor.door_security.base',
    value: 'security',
  },
]

export const ENERGY_CLASS_OPTIONS: EnergyClassOption[] = [
  {
    label: 'property.estatePropertyEnergyClass.aPlus.base',
    value: 'a+',
  },
  {
    label: 'property.estatePropertyEnergyClass.a.base',
    value: 'a',
  },
  {
    label: 'property.estatePropertyEnergyClass.bPlus.base',
    value: 'b+',
  },
  {
    label: 'property.estatePropertyEnergyClass.b.base',
    value: 'b',
  },
  {
    label: 'property.estatePropertyEnergyClass.c.base',
    value: 'c',
  },
  {
    label: 'property.estatePropertyEnergyClass.d.base',
    value: 'd',
  },
  {
    label: 'property.estatePropertyEnergyClass.e.base',
    value: 'e',
  },
  {
    label: 'property.estatePropertyEnergyClass.f.base',
    value: 'f',
  },
  {
    label: 'property.estatePropertyEnergyClass.g.base',
    value: 'g',
  },
  {
    label: 'property.estatePropertyEnergyClass.h.base',
    value: 'h',
  },
  {
    label: 'property.estatePropertyEnergyClass.z.base',
    value: 'z',
  },
  {
    label: 'property.estatePropertyEnergyClass.notProvided.base',
    value: 'not_provided',
  },
]

export const GARDEN_OPTIONS: GardenOption[] = [
  {
    label: 'property.estatePropertyGarden.has.base',
    value: 'has',
  },
  {
    label: 'property.estatePropertyGarden.hasNot.base',
    value: 'has_not',
  },
  {
    label: 'property.estatePropertyGarden.private.base',
    value: 'private',
  },
  {
    label: 'property.estatePropertyGarden.communal.base',
    value: 'communal',
  },
]

export const FRAME_OPTIONS: FrameOption[] = [
  {
    label: 'property.estatePropertyFrames.aluminium.base',
    value: 'aluminium',
  },
  {
    label: 'property.estatePropertyFrames.aluminiumSliding.base',
    value: 'aluminium_sliding',
  },
  {
    label: 'property.estatePropertyFrames.synthetic.base',
    value: 'synthetic',
  },
  {
    label: 'property.estatePropertyFrames.wooden.base',
    value: 'wooden',
  },
  {
    label: 'property.estatePropertyFrames.pvc.base',
    value: 'pvc',
  },
]

export const WINDOW_OPTIONS: WindowOption[] = [
  {
    label: 'property.estatePropertyWindowType.single.base',
    value: 'single',
  },
  {
    label: 'property.estatePropertyWindowType.double.base',
    value: 'double',
  },
]

export const FLOOR_TYPE_OPTIONS: FloorTypeOption[] = [
  {
    label: 'property.estatePropertyFloorType.marbles.base',
    value: 'marbles',
  },
  {
    label: 'property.estatePropertyFloorType.wood.base',
    value: 'wood',
  },
  {
    label: 'property.estatePropertyFloorType.stone.base',
    value: 'stone',
  },
  {
    label: 'property.estatePropertyFloorType.tile.base',
    value: 'tile',
  },
  {
    label: 'property.estatePropertyFloorType.mosaic.base',
    value: 'mosaic',
  },
  {
    label: 'property.estatePropertyFloorType.marble_wood.base',
    value: 'marble_wood',
  },
  {
    label: 'property.estatePropertyFloorType.marble_tile.base',
    value: 'marble_tile',
  },
  {
    label: 'property.estatePropertyFloorType.stone_wood.base',
    value: 'stone_wood',
  },
  {
    label: 'property.estatePropertyFloorType.stone_marble.base',
    value: 'stone_marble',
  },
  {
    label: 'property.estatePropertyFloorType.tile_wood.base',
    value: 'tile_wood',
  },
  {
    label: 'property.estatePropertyFloorType.mosaic_wood.base',
    value: 'mosaic_wood',
  },
  {
    label: 'property.estatePropertyFloorType.unspecified.base',
    value: 'unspecified',
  },
  {
    label: 'property.estatePropertyFloorType.cement_mortat.base',
    value: 'cement_mortat',
  },
  {
    label: 'property.estatePropertyFloorType.laminate.base',
    value: 'laminate',
  },
  {
    label: 'property.estatePropertyFloorType.granite.base',
    value: 'granite',
  },
  {
    label: 'property.estatePropertyFloorType.industrial_flooring.base',
    value: 'industrial_flooring',
  },
  {
    label: 'property.estatePropertyFloorType.granite_wood.base',
    value: 'granite_wood',
  },
  {
    label: 'property.estatePropertyFloorType.traditional_stone.base',
    value: 'traditional_stone',
  },
  {
    label: 'property.estatePropertyFloorType.canvas.base',
    value: 'canvas',
  },
  {
    label: 'property.estatePropertyFloorType.oak.base',
    value: 'oak',
  },
  {
    label: 'property.estatePropertyFloorType.parquet.base',
    value: 'parquet',
  },
  {
    label: 'property.estatePropertyFloorType.plastic.base',
    value: 'plastic',
  },
]

export const ACCESS_OPTIONS: AccessOption[] = [
  {
    label: 'property.estatePropertyAccess.asphalt.base',
    value: 'asphalt',
  },
  {
    label: 'property.estatePropertyAccess.pavement.base',
    value: 'pavement',
  },
  {
    label: 'property.estatePropertyAccess.paved.base',
    value: 'paved',
  },
  {
    label: 'property.estatePropertyAccess.dirtRoad.base',
    value: 'dirt_road',
  },
  {
    label: 'property.estatePropertyAccess.noRoad.base',
    value: 'no_road',
  },
  {
    label: 'property.estatePropertyAccess.ruralRoad.base',
    value: 'rural_road',
  },
  {
    label: 'property.estatePropertyAccess.municipalRoad.base',
    value: 'minicipal_road',
  },
  {
    label: 'property.estatePropertyAccess.countryRoad.base',
    value: 'country_road',
  },
  {
    label: 'property.estatePropertyAccess.sea.base',
    value: 'sea',
  },
  {
    label: 'property.estatePropertyAccess.nationalRoad.base',
    value: 'national_road',
  },
  {
    label: 'property.estatePropertyAccess.commonAre.base',
    value: 'common_are',
  },
  {
    label: 'property.estatePropertyAccess.subway.base',
    value: 'subway',
  },
  {
    label: 'property.estatePropertyAccess.suburban.base',
    value: 'suburban',
  },
  {
    label: 'property.estatePropertyAccess.electric.base',
    value: 'electric',
  },
  {
    label: 'property.estatePropertyAccess.attikiOdos.base',
    value: 'attiki_odos',
  },
  {
    label: 'property.estatePropertyAccess.immediate.base',
    value: 'immediate',
  },
  {
    label: 'property.estatePropertyAccess.difficult.base',
    value: 'difficult',
  },
  {
    label: 'property.estatePropertyAccess.good.base',
    value: 'good',
  },
  {
    label: 'property.estatePropertyAccess.moderate.base',
    value: 'moderate',
  },
  {
    label: 'property.estatePropertyAccess.bus.base',
    value: 'bus',
  },
  {
    label: 'property.estatePropertyAccess.ktel.base',
    value: 'ktel',
  },
  {
    label: 'property.estatePropertyAccess.ose.base',
    value: 'ose',
  },
  {
    label: 'property.estatePropertyAccess.tram.base',
    value: 'tram',
  },
  {
    label: 'property.estatePropertyAccess.sidewalk.base',
    value: 'sidewalk',
  },
  {
    label: 'property.estatePropertyAccess.unspecified.base',
    value: 'unspecified',
  },
]

export const DIRECTION_OPTIONS: DirectionOption[] = [
  {
    label: 'property.estatePropertyDirection.east.base',
    value: 'east',
  },
  {
    label: 'property.estatePropertyDirection.west.base',
    value: 'west',
  },
  {
    label: 'property.estatePropertyDirection.east_meridian.base',
    value: 'east_meridian',
  },
  {
    label: 'property.estatePropertyDirection.north.base',
    value: 'north',
  },
  {
    label: 'property.estatePropertyDirection.north_east.base',
    value: 'north_east',
  },
  {
    label: 'property.estatePropertyDirection.north_west.base',
    value: 'north_west',
  },
  {
    label: 'property.estatePropertyDirection.west_meridian.base',
    value: 'west_meridian',
  },
  {
    label: 'property.estatePropertyDirection.meridian.base',
    value: 'meridian',
  },
  {
    label: 'property.estatePropertyDirection.south.base',
    value: 'south',
  },
  {
    label: 'property.estatePropertyDirection.south_east.base',
    value: 'south_east',
  },
  {
    label: 'property.estatePropertyDirection.south_west.base',
    value: 'south_west',
  },
  {
    label: 'property.estatePropertyDirection.undefined.base',
    value: 'undefined',
  },
]

export const VIEW_OPTIONS: ViewOption[] = [
  {
    label: 'property.estatePropertyView.unlimited.base',
    value: 'unlimited',
  },
  {
    label: 'property.estatePropertyView.forest.base',
    value: 'forest',
  },
  {
    label: 'property.estatePropertyView.mountain.base',
    value: 'mountain',
  },
  {
    label: 'property.estatePropertyView.sea.base',
    value: 'sea',
  },
  {
    label: 'property.estatePropertyView.park.base',
    value: 'park',
  },
  {
    label: 'property.estatePropertyView.square.base',
    value: 'square',
  },
  {
    label: 'property.estatePropertyView.good.base',
    value: 'good',
  },
  {
    label: 'property.estatePropertyView.sea_park.base',
    value: 'sea_park',
  },
  {
    label: 'property.estatePropertyView.panoramic.base',
    value: 'panoramic',
  },
  {
    label: 'property.estatePropertyView.mountain_sea.base',
    value: 'mountain_sea',
  },
  {
    label: 'property.estatePropertyView.cityscape.base',
    value: 'cityscape',
  },
  {
    label: 'property.estatePropertyView.outdoors.base',
    value: 'outdoors',
  },
  {
    label: 'property.estatePropertyView.open_horizon.base',
    value: 'open_horizon',
  },
  {
    label: 'property.estatePropertyView.side_view.base',
    value: 'side_view',
  },
  {
    label: 'property.estatePropertyView.acropole.base',
    value: 'acropole',
  },
  {
    label: 'property.estatePropertyView.garden.base',
    value: 'garden',
  },
]

export const POOL_OPTIONS: PoolOption[] = [
  {
    label: 'property.estatePropertyPool.interior.base',
    value: 'interior',
  },
  {
    label: 'property.estatePropertyPool.exterior.base',
    value: 'exterior',
  },
  {
    label: 'property.estatePropertyPool.private.base',
    value: 'private',
  },
  {
    label: 'property.estatePropertyPool.communal.base',
    value: 'communal',
  },
  {
    label: 'property.estatePropertyPool.no_pool.base',
    value: 'no_pool',
  },
  {
    label: 'property.estatePropertyPool.yes.base',
    value: 'yes',
  },
]

export const USAGE_OPTIONS: UsageOption[] = [
  {
    label: 'property.estatePropertyUsage.pure_house.base',
    value: 'pure_house',
  },
  {
    label: 'property.estatePropertyUsage.industrial_zone.base',
    value: 'industrial_zone',
  },
  {
    label: 'property.estatePropertyUsage.craft_zone.base',
    value: 'craft_zone',
  },
  {
    label: 'property.estatePropertyUsage.grazing_land.base',
    value: 'grazing_land',
  },
  {
    label: 'property.estatePropertyUsage.general_house.base',
    value: 'general_house',
  },
  {
    label: 'property.estatePropertyUsage.forest_area.base',
    value: 'forest_area',
  },
  {
    label: 'property.estatePropertyUsage.red_zone.base',
    value: 'red_zone',
  },
  {
    label: 'property.estatePropertyUsage.arable_land.base',
    value: 'arable_land',
  },
  {
    label: 'property.estatePropertyUsage.tourist_investment.base',
    value: 'tourist_investment',
  },
  {
    label:
      'property.estatePropertyUsage.industrial_park_light_industrial_serving.base',
    value: 'industrial_park_light_industrial_serving',
  },
  {
    label:
      'property.estatePropertyUsage.industrial_park_full_industrial_serving.base',
    value: 'industrial_park_full_industrial_serving',
  },
  {
    label:
      'property.estatePropertyUsage.industrial_park_low_and_medium_industrial_serving.base',
    value: 'industrial_park_low_and_medium_industrial_serving',
  },
  {
    label: 'property.estatePropertyUsage.uncharacteristic_zone.base',
    value: 'uncharacteristic_zone',
  },
  {
    label: 'property.estatePropertyUsage.wholesale_zone.base',
    value: 'wholesale_zone',
  },
  {
    label: 'property.estatePropertyUsage.agricultural_area.base',
    value: 'agricultural_area',
  },
  {
    label: 'property.estatePropertyUsage.commercial_zone.base',
    value: 'commercial_zone',
  },
  {
    label: 'property.estatePropertyUsage.unspecified.base',
    value: 'unspecified',
  },
  {
    label: 'property.estatePropertyUsage.farmers_buildings.base',
    value: 'farmers_buildings',
  },
  {
    label: 'property.estatePropertyUsage.agricultural_warehouses.base',
    value: 'agricultural_warehouses',
  },
  {
    label: 'property.estatePropertyUsage.tanks.base',
    value: 'tanks',
  },
  {
    label: 'property.estatePropertyUsage.greenhouses.base',
    value: 'greenhouses',
  },
  {
    label: 'property.estatePropertyUsage.industrial_buildings.base',
    value: 'industrial_buildings',
  },
  {
    label: 'property.estatePropertyUsage.warehouses.base',
    value: 'warehouses',
  },
  {
    label: 'property.estatePropertyUsage.sports_facilities.base',
    value: 'sports_facilities',
  },
  {
    label: 'property.estatePropertyUsage.schools.base',
    value: 'schools',
  },
  {
    label: 'property.estatePropertyUsage.charitable_foundations.base',
    value: 'charitable_foundations',
  },
  {
    label: 'property.estatePropertyUsage.hospitals.base',
    value: 'hospitals',
  },
  {
    label: 'property.estatePropertyUsage.clinics.base',
    value: 'clinics',
  },
  {
    label: 'property.estatePropertyUsage.offices.base',
    value: 'offices',
  },
  {
    label: 'property.estatePropertyUsage.stores.base',
    value: 'stores',
  },
  {
    label: 'property.estatePropertyUsage.tourist_facilities.base',
    value: 'tourist_facilities',
  },
  {
    label: 'property.estatePropertyUsage.churches.base',
    value: 'churches',
  },
  {
    label: 'property.estatePropertyUsage.within_the_urban_plan.base',
    value: 'within_the_urban_plan',
  },
  {
    label: 'property.estatePropertyUsage.out_of_the_urban_plan.base',
    value: 'out_of_the_urban_plan',
  },
  {
    label: 'property.estatePropertyUsage.mild_harassment.base',
    value: 'mild_harassment',
  },
  {
    label: 'property.estatePropertyUsage.urban_center.base',
    value: 'urban_center',
  },
  {
    label: 'property.estatePropertyUsage.public_benefit_organizations.base',
    value: 'public_benefit_organizations',
  },
  {
    label: 'property.estatePropertyUsage.audience_gathering_space.base',
    value: 'audience_gathering_space',
  },
  {
    label: 'property.estatePropertyUsage.religious_space.base',
    value: 'religious_space',
  },
]

export const PLAN_OPTIONS: PlanOption[] = [
  {
    label: 'property.estatePropertyCityPlan.out.base',
    value: 'out_of_city_plans',
  },
  {
    label: 'property.estatePropertyCityPlan.in.base',
    value: 'in_city_plans',
  },
  {
    label: 'property.estatePropertyCityPlan.withinSettlement.base',
    value: 'within_settlement',
  },
  {
    label: 'property.estatePropertyCityPlan.inBuildingZone.base',
    value: 'in_building_zone',
  },
  {
    label: 'property.estatePropertyCityPlan.settlementLimits.base',
    value: 'settlement_limits',
  },
  {
    label: 'property.estatePropertyCityPlan.tangentialPlan.base',
    value: 'tangential_plan',
  },
  {
    label: 'property.estatePropertyCityPlan.toBeIncluded.base',
    value: 'to_be_included',
  },
]

export const LAND_CONDITION_OPTIONS: LandConditionOption[] = [
  {
    label: 'property.estatePropertyLandCondition.even.base',
    value: 'even',
  },
  {
    label: 'property.estatePropertyLandCondition.buildable.base',
    value: 'buildable',
  },
]

export const ELECTRICITY_TYPE_OPTIONS: ElectricityTypeOption[] = [
  {
    label: 'property.estatePropertyElectricityType.typeA.base',
    value: 'electricity_type_a',
  },
  {
    label: 'property.estatePropertyElectricityType.typeB.base',
    value: 'electricity_type_b',
  },
  {
    label: 'property.estatePropertyElectricityType.night.base',
    value: 'night_electricity',
  },
  {
    label: 'property.estatePropertyElectricityType.triPhase.base',
    value: 'three_phase',
  },
  {
    label: 'property.estatePropertyElectricityType.singlePhase.base',
    value: 'single_phase',
  },
  {
    label: 'property.estatePropertyElectricityType.industrial.base',
    value: 'industrial',
  },
  {
    label: 'property.estatePropertyElectricityType.mediumPower.base',
    value: 'medium_power',
  },
  {
    label: 'property.estatePropertyElectricityType.highPower.base',
    value: 'high_power',
  },
  {
    label: 'property.estatePropertyElectricityType.substation.base',
    value: 'substation',
  },
]

export const EQUIPMENT_OPTIONS: EquipmentOption[] = [
  {
    label: 'property.estatePropertyEquipment.restaurant.base',
    value: 'restaurant',
  },
  {
    label: 'property.estatePropertyEquipment.cafe.base',
    value: 'cafe',
  },
  {
    label: 'property.estatePropertyEquipment.office.base',
    value: 'office',
  },
  {
    label: 'property.estatePropertyEquipment.hair_salon.base',
    value: 'hair_salon',
  },
  {
    label: 'property.estatePropertyEquipment.pastry_shop.base',
    value: 'pastry_shop',
  },
  {
    label: 'property.estatePropertyEquipment.jewelery_store.base',
    value: 'jewelery_store',
  },
  {
    label: 'property.estatePropertyEquipment.bookstore.base',
    value: 'bookstore',
  },
  {
    label: 'property.estatePropertyEquipment.store.base',
    value: 'store',
  },
  {
    label: 'property.estatePropertyEquipment.exhibition_space.base',
    value: 'exhibition_space',
  },
  {
    label: 'property.estatePropertyEquipment.food.base',
    value: 'food',
  },
  {
    label: 'property.estatePropertyEquipment.printing.base',
    value: 'printing',
  },
  {
    label: 'property.estatePropertyEquipment.chemicals.base',
    value: 'chemicals',
  },
  {
    label: 'property.estatePropertyEquipment.petrochemicals_plastics.base',
    value: 'petrochemicals_plastics',
  },
  {
    label: 'property.estatePropertyEquipment.wood_processing.base',
    value: 'wood_processing',
  },
  {
    label: 'property.estatePropertyEquipment.tanners.base',
    value: 'tanners',
  },
  {
    label: 'property.estatePropertyEquipment.farming.base',
    value: 'farming',
  },
  {
    label: 'property.estatePropertyEquipment.metal_processing.base',
    value: 'metal_processing',
  },
  {
    label: 'property.estatePropertyEquipment.paper_processing.base',
    value: 'paper_processing',
  },
  {
    label: 'property.estatePropertyEquipment.textile_industry.base',
    value: 'textile_industry',
  },
]
